import { useEffect, useState } from "react";
import { ref, set, onValue } from "firebase/database";
import type { IMeal } from "../types/types";
import { realtimeDb } from "../utils/firebase";

export function useCart() {
  const [cart, setCart] = useState<IMeal[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const cartRef = ref(realtimeDb, "cart");

  const updateCart = async (updater: ((prev: IMeal[]) => IMeal[]) | IMeal[]) => {
    let value = cart
    if (typeof updater === "function") {
      value = updater(value);
    } else {
      value = updater;
    }
    try {
      setCart(value)
      await set(cartRef, value);
    } catch (err) {
      console.error("Błąd aktualizacji koszyka:", err);
    }
  }


  useEffect(() => {
      const unsubscribe = onValue(
        cartRef,
        snapshot => {
          const data = snapshot.exists() ? snapshot.val() : {};
          setCart(Object.values(data));
          setLoading(false);
        },
        err => {
          setError(err.message);
          setLoading(false);
        }
      );

      return () => unsubscribe();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return { cart, setCart: updateCart, loading, error };
}
